<template>
  <div data-testid="exercise_score_summary_default">
    <table>
      <tr v-for="field in summary_fields" :key="field.name">
        <td class="pr-6"><strong>{{ field_title(field.config) }}</strong></td>
        <td v-if="!field.config.boolean_label_only">
          {{ field_value(field.id) }}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { exercise_score_display } from "../classes/exercise.ts";
import nunjucks from 'nunjucks';

export default {
  props: {
    exercise: {
      type: Object,
      required: true,
    },
    score: {
      type: Object,
      required: true,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    context: {
      type: String,
      required: false,
    },
    config: {
      type: Object,
      required: false,
    }
  },
  computed: {
    summary_fields() {
      let summary_fields = []

      for (const [field_id, field_config] of Object.entries(this.exercise.reporting)) {
        if (!field_config.summary) continue;

        if (field_config.display_if) {
          let display_if_value = this.score[field_config.display_if];
          if (!display_if_value) {
            continue;
          }
        }

        let field_value = this.score[field_id];

        if (field_value === undefined) {
          continue;
        }

        if (field_config.display === 'boolean_label_only') {
          if (!field_value) {
            continue;
          }
        }

        summary_fields.push({
          id: field_id,
          config: field_config,
        });
      }

      return summary_fields;
    },
  },
  methods: {
    render_nunjucks_template(template_string) {
      if (!template_string) {
        return '';
      }

      let template_env = new nunjucks.Environment();

      // Global translation function
      template_env.addGlobal('t', (prefix, key) => {
        const full_key = key ? `${prefix}.${key}` : prefix;
        return this.$t(full_key);
      });

      const context = {
        score: this.score,
        config: this.config || {},
      };

      try {
        return template_env.renderString(template_string, context);
      } catch (error) {
        console.error('Error rendering nunjucks template:', error);
        return template_string;
      }
    },
    field_title(field_config) {
      let current_lang = this.$i18n.locale.slice(0, 2);
      let title = field_config.title[current_lang] || field_config.title.en;
      return this.render_nunjucks_template(title);
    },
    field_value(field_id) {
      return exercise_score_display(this.exercise, field_id, this.score, this.config, this.$i18n);
    }
  }
};
</script>

